import { IAddress, IAddressVerdict, IAutocompleteEntry, IBinLocation, ICheckableAddress, IHint, IHintRequest, IIOrderDao$IOrderTemplate, IOrderHeader, IOrderLine } from 'interfaces';
import { Registry } from '.';
import { saveBase64UrlEncode } from 'component_utils/utils';

export default ({ get, post, destroy }: Registry) => {
  return {
    order: {
      createPurchaseOrder: (template: IIOrderDao$IOrderTemplate) => post('/api/v1/purchaseOrder', template),
      createPurchaseOrderDraft: (template: IIOrderDao$IOrderTemplate) => post('/api/v1/purchaseOrderDraft', template),
      createSalesOrder: (template: IIOrderDao$IOrderTemplate) => post('/api/v1/order', template),
    
      markOrderPushedToKardex: (code: string) => post(`/api/v1/order/${code}/markPushedToKardex`, {}),
      setReleasedForPickAndCollectStatus: (code: string, released: boolean, orderGroup: string) => post(`/api/v1/order/${code}/setReleasedForPickAndCollectStatus`, { released, orderGroup }),

      printOrderDocument: (code: string, printerId: number): Promise<void> => post(`/api/v1/order/${code}/print/${printerId}`, {}),
      getOrdersToDeliver: (): Promise<IOrderHeader[]> => get('/api/v1/orders_to_deliver'),
      getOrder: (code: string): Promise<IOrderHeader> => get(`/api/v1/order/${code}`),
      getOrders: (codes: string[]): Promise<IOrderHeader[]> => post(`/api/v1/order/`, codes),
      findOrder: (code: string): Promise<IOrderHeader> => get(`/api/v1/order/find/${code}`),
      getActiveOrdersInGroup: (code: string): Promise<IOrderHeader[]> => code === null ? Promise.resolve([]) : get(`/api/v1/order/active_by_group/${saveBase64UrlEncode(code)}`),
      getActiveOrdersInMutlipleGroups: (codes: string[]): Promise<{[k:string]:IOrderHeader[]}> => post(`/api/v1/order/active_by_multiple_group/`, codes),
      getOrderLines: (code: string, context: string): Promise<IOrderLine[]> => get(`/api/v1/order/${code}/lines`, { context }),
      getOrderLinesForMultiple: (codes: string[], context: string): Promise<IOrderLine[]> => post(`/api/v1/order/lines_for_multiple`, codes, { context }),
      getOrderAutoComplete: (code: string): Promise<IAutocompleteEntry[]> => get(`/api/v1/order/autocomplete/${code}`),

      pickAndCollect: {
        getOrders: (): Promise<IOrderHeader[]> => get('/api/v1/pick_and_collect/order'),
        getHints: (
          requests: IHintRequest[],
          forceLocation: IBinLocation,
        ): Promise<IHint[]> => post('/api/v1/pick_and_collect/hints', { requests, forceLocation })
      },

      address: {
        getRequiresValidation: (): Promise<ICheckableAddress[]> => get('/api/v1/address/requiresValidation'),
        checkAddress: (type: string, code: string, address: IAddress): Promise<IAddressVerdict> => post(`/api/v1/address/${type}/${code}/addressCheck`, address),
        setAddress: (type: string, code: string, address: IAddress): Promise<any> => post(`/api/v1/address/${type}/${code}/address`, address),
        setValidationVerdict: (type: string, code: string, verdict: boolean): Promise<any> => post(`/api/v1/address/${type}/${code}/address/verdict/${verdict}`, null),
      },
    },
  };
};
